import { render, staticRenderFns } from "./df-page-notifications.vue?vue&type=template&id=c40fac80"
import script from "./df-page-notifications.ts?vue&type=script&lang=js&external"
export * from "./df-page-notifications.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports